import _sfc_main from "./component-library224.mjs";
import "./component-library225.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.BaseDialog, { ref: "baseDialog", class: ["flyout", _vm.customClass], attrs: { "heading-text": _vm.headingText, "custom-container-class": {
    "base-dialog__container--success": _vm.success,
    "base-dialog__container--error": _vm.error,
    "base-dialog__container--warning": _vm.warning
  }, "close-on-backdrop": _vm.closeOnBackdrop, "disable-focus-trap": _vm.disableFocusTrap, "data-tealium-rel": _vm.dataTealiumRel, "close-autofocus": _vm.closeAutofocus }, scopedSlots: _vm._u([{ key: "trigger", fn: function({ open }) {
    return [_vm._t("trigger", null, { "open": open })];
  } }, { key: "header", fn: function({ close }) {
    return [_vm._t("header", null, { "close": close })];
  } }, { key: "default", fn: function({ close }) {
    return [_vm._t("default", null, { "close": close })];
  } }, { key: "footer", fn: function({ close }) {
    return [_vm._t("footer", null, { "close": close })];
  } }], null, true) });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "ae19256b",
  null,
  null
);
const flyout = __component__.exports;
export {
  flyout as default
};
